/**
 * HTTP Client — 无 case 转换的干净 HTTP 客户端
 *
 * 设计原则：
 * 1. 基于现有 axios 实例（含 token 附加 + 401 刷新 + 响应解包）
 * 2. 不做任何 camelCase ↔ snake_case 转换
 * 3. 请求参数和响应字段均为 snake_case（与后端 DTO 一致）
 * 4. 新代码优先使用此 client；旧代码通过 apiAdapter 渐进迁移
 *
 * 用法：
 *   import { get, post, patch, del } from '@/network/client'
 *   const res = await get<{ code: number; data: Foo[] }>('webofficial/addresses')
 */
import { request } from '@/network/axios'

/**
 * GET 请求
 * @param url 相对路径（不含 /api 前缀，axios baseURL 已配置）
 * @param params 查询参数（snake_case 键名）
 */
export const get = <T = any>(url: string, params?: object): Promise<T> => {
  return request.get<T>(url, params)
}

/**
 * POST 请求
 * @param url 相对路径
 * @param data 请求体（snake_case 键名）
 * @param params 查询参数（可选）
 */
export const post = <T = any>(url: string, data?: object, params?: object): Promise<T> => {
  return request.post<T>(url, data, params)
}

/**
 * PUT 请求
 */
export const put = <T = any>(url: string, data?: object, params?: object): Promise<T> => {
  return request.put<T>(url, data, params)
}

/**
 * PATCH 请求
 */
export const patch = <T = any>(url: string, data?: object): Promise<T> => {
  return request.patch<T>(url, data)
}

/**
 * DELETE 请求
 * @param url 相对路径
 * @param data 请求体（可选，部分 DELETE 需要 body）
 */
export const del = <T = any>(url: string, data?: object): Promise<T> => {
  return request.delete<T>(url, data ? { data } : undefined)
}
